/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { GradeFrequenceClassViewModel } from "../types/GradeFrequenceClassViewModel.ts";
import { eClassRoomDisciplinesStatusSchema } from "./eClassRoomDisciplinesStatusSchema.ts";
import { gradeFrequenceExamInfoViewModelSchema } from "./gradeFrequenceExamInfoViewModelSchema.ts";

export const gradeFrequenceClassViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  name: z.string().nullish(),
  startDate: z.optional(z.string().date()),
  status: z.optional(
    z
      .lazy(() => eClassRoomDisciplinesStatusSchema)
      .describe("1 = Planned | 2 = Finished | 3 = Canceled | 4 = Confirmed | "),
  ),
  examInfo: z.optional(z.lazy(() => gradeFrequenceExamInfoViewModelSchema)),
}) as unknown as ToZod<GradeFrequenceClassViewModel>;
